import { useRouter } from 'next/router';
import React from 'react';
import DetailsPage from './DetailsPage';
import VideoModal from 'app/components/VideoModal/VideoModal';

export const VideoEntry = ({ videoId }) => {
    const router = useRouter();
    const openModal = Boolean(router.query.modalId);

    return (
        <>
            {openModal && <VideoModal id={router.query.modalId} />}
            <DetailsPage id={videoId} openModal={openModal} />
        </>
    );
};

export default VideoEntry;
